<template>
  <output-dialog
    :aspectRatio="849/1000"
    :background="require('@/assets/img/JpModel.jpg')"
    :fields="fields"
    :pages="pages"
    filename="JpModel.pdf"
    orientation="portrait"
    ref="printDlg"
    title="取引先用 登録用紙（日本語）"
  />
</template>
<script>
export default {
  data() {
    return {
      fields: [
        {
          name: 'name1',
          style: {
            left: '330px',
            top: '540.79px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name2',
          style: {
            left: '366.73px',
            top: '540.79px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name3',
          style: {
            left: '406.73px',
            top: '540.79px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name4',
          style: {
            left: '450.73px',
            top: '540.79px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name5',
          style: {
            left: '496.73px',
            top: '540.79px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name6',
          style: {
            left: '536.73px',
            top: '540.79px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name7',
          style: {
            left: '566.73px',
            top: '540.79px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name8',
          style: {
            left: '606.73px',
            top: '540.79px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name9',
          style: {
            left: '646.73px',
            top: '540.79px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name',
          style: {
            left: '336.73px',
            top: '570.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'showName',
          style: {
            left: '336.73px',
            top: '600.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'englishName',
          style: {
            left: '336.73px',
            top: '630.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'companyName',
          style: {
            left: '336.73px',
            top: '660.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'companyType',
          style: {
            left: '336.73px',
            top: '690.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'position',
          style: {
            left: '336.73px',
            top: '720.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'email',
          style: {
            left: '336.73px',
            top: '810.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'outsideLineNumber',
          style: {
            left: '336.73px',
            top: '750.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'insideLineNumber',
          style: {
            left: '336.73px',
            top: '780.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        }
      ],
      pages: []
    }
  },
  methods: {
    popup(pages) {
      this.$refs.printDlg.show = true
      this.pages = pages
    }
  }
}
</script>